import { AssessmentStepKeys } from '@/enums/assessment'

const steps = {
  CO: [
    AssessmentStepKeys.businessTypeAi,
    AssessmentStepKeys.businessTypeConfirmationAi,
    AssessmentStepKeys.businessTypeMainSelectionAi,
    AssessmentStepKeys.companyFoundedDateLead,
    AssessmentStepKeys.approxRevenue,
    AssessmentStepKeys.inventory,
    AssessmentStepKeys.companyDetails,
    AssessmentStepKeys.locationDetails,
  ],
  EL: [
    AssessmentStepKeys.businessTypeAi,
    AssessmentStepKeys.businessTypeConfirmationAi,
    AssessmentStepKeys.businessTypeMainSelectionAi,
    AssessmentStepKeys.companyFoundedDateLead,
    AssessmentStepKeys.approxRevenue,
    AssessmentStepKeys.costOfElectronics,
    AssessmentStepKeys.companyDetails,
  ],
  default: [
    AssessmentStepKeys.businessTypeAi,
    AssessmentStepKeys.businessTypeConfirmationAi,
    AssessmentStepKeys.businessTypeMainSelectionAi,
    AssessmentStepKeys.companyFoundedDateLead,
    AssessmentStepKeys.approxRevenue,
    AssessmentStepKeys.employeesCount,
    AssessmentStepKeys.approxLaborCosts,
    AssessmentStepKeys.companyDetails,
  ],
}

export const makeSteps = (categoryId: string, poaSigned: boolean) => {
  let stepKeys: string[] =
    steps[categoryId as keyof typeof steps] || steps.default

  if (poaSigned) {
    stepKeys = stepKeys.filter(
      (step) => step !== AssessmentStepKeys.companyDetails,
    )
  }

  return stepKeys
}
